import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createBlock(_component_VueMultiselect, {
    disabled: _ctx.disabled,
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    options: _ctx.Options,
    multiple: false,
    allowEmpty: false,
    selectLabel: "",
    deselectLabel: "",
    selectedLabel: "",
    "close-on-select": true,
    "clear-on-select": false,
    class: "next-vue-multiselect-single",
    "track-by": "id",
    label: "text"
  }, {
    noResult: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode("Nessun elemento trovato.")
    ])),
    _: 1
  }, 8, ["disabled", "modelValue", "options"]))
}